import { DropdownOptionItem, Field, FieldMap } from '../../types/forms/fields'
import { getBooleanHistoryField } from '../shared'
import { getConditionOrDiseaseFields, getDetailsField } from './shared'

const depressionAnxietyOrOtherOptions: Array<DropdownOptionItem> = [
  {
    text: 'Depression',
    id: 'depression',
  },
  {
    text: 'Anxiety or panic attacks',
    id: 'anxiety-or-panic-attacks',
  },
  {
    text: 'Psychosis',
    id: 'psychosis',
  },
  {
    text: 'Bipolar affective disorder',
    id: 'bipolar-affective-disorder',
  },
  {
    text: 'Schizophrenia',
    id: 'schizophrenia',
  },
  {
    text: 'Other',
    id: 'other',
  },
]

const depressionAnxietyOrOtherFields: Record<string, Field> = getConditionOrDiseaseFields(
  'depressionAnxietyOrOther',
  'Depression, anxiety, panic attacks, or other mental health condition',
  depressionAnxietyOrOtherOptions,
)

const migranesOrChronicHeadachesFields: Record<string, Field> = getConditionOrDiseaseFields(
  'migranesOrChronicHeadaches',
  'Migraines or chronic headaches',
)

const neurologicProblemsOrSeizuresFields: Record<string, Field> = getConditionOrDiseaseFields(
  'neurologicProblemsOrSeizures',
  'Neurologic problems or seizures',
)

const intellectualOrLearningDisabilityOptions: Array<DropdownOptionItem> = [
  {
    text: 'ADHD/ADD',
    id: 'adhd-add',
  },
  {
    text: 'Down syndrome',
    id: 'down-syndrome',
  },
  {
    text: 'Fragile X syndrome',
    id: 'fragile-x-syndrome',
  },
  {
    text: 'Fetal alcohol syndrome',
    id: 'fetal-alcohol-syndrome',
  },
  {
    text: 'Other',
    id: 'other',
  },
]

const intellectualOrLearningDisabilityFields: Record<string, Field> = getConditionOrDiseaseFields(
  'intellectualOrLearningDisability',
  'Intellectual or learning disability',
  intellectualOrLearningDisabilityOptions,
  'How do you understand information best (written, verbal, visual, etc.)?',
)

const autismSpectrumFields: Record<string, Field> = getConditionOrDiseaseFields(
  'autismSpectrum',
  'Autism or other condition on the Autism spectrum',
)

export const neurologicalPsychologicalFieldGroups: Array<Record<string, Field>> = [
  depressionAnxietyOrOtherFields,
  migranesOrChronicHeadachesFields,
  neurologicProblemsOrSeizuresFields,
  intellectualOrLearningDisabilityFields,
  autismSpectrumFields,
]

export const hasCurrentMentalHealthCareProviderField: Field = getBooleanHistoryField(
  'Do you have a current mental health care provider?',
)

export const currentMentalHealthCareProviderDetailsField = getDetailsField(
  'hasCurrentMentalHealthCareProvider',
  undefined,
  true,
)

export const neurologicalPsychologicalField: FieldMap = {
  name: 'Neurological and Psychological',
  children: {
    hasCurrentMentalHealthCareProvider: hasCurrentMentalHealthCareProviderField,
    currentMentalHealthCareProviderDetails: currentMentalHealthCareProviderDetailsField,
    ...depressionAnxietyOrOtherFields,
    ...migranesOrChronicHeadachesFields,
    ...neurologicProblemsOrSeizuresFields,
    ...intellectualOrLearningDisabilityFields,
    ...autismSpectrumFields,
  },
}
